import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUser } from '../services/auth';

export default function Dashboard() {
  const navigate = useNavigate();
  const user = getUser();

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }

    // Redirect based on role
    const role = user.role;

    if (role === 'admin' || role === 'platform_admin') {
      navigate('/dashboard/admin', { replace: true });
      return;
    }

    if (role === 'parent') {
      navigate('/dashboard/parent', { replace: true });
      return;
    }

    if (role === 'babysitter') {
      navigate('/dashboard/babysitter', { replace: true });
      return;
    }

    // Unknown role – send to generic dashboard (parent) as fallback
    navigate('/dashboard/parent', { replace: true });
  }, [user, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Preusmeravanje...</p>
      </div>
    </div>
  );
}

